// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:29
import { KeywordSearchTypes_abstract } from './../../abstract/SagaBase/Objects/KeywordSearchTypes_abstract';
export class KeywordSearchTypes extends KeywordSearchTypes_abstract {}
